import { render, staticRenderFns } from "./AftersaleRemarkDialog.vue?vue&type=template&id=2129de48&scoped=true"
import script from "./AftersaleRemarkDialog.vue?vue&type=script&lang=js"
export * from "./AftersaleRemarkDialog.vue?vue&type=script&lang=js"
import style0 from "./AftersaleRemarkDialog.vue?vue&type=style&index=0&id=2129de48&prod&scoped=true&lang=css"
import style1 from "./AftersaleRemarkDialog.vue?vue&type=style&index=1&id=2129de48&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2129de48",
  null
  
)

export default component.exports